const MONTHS = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

const MONTH_NAME_TO_INDEX: Record<string, number> = MONTHS.reduce(
  (monthMap, month, index) => {
    monthMap[month.toLowerCase()] = index;
    return monthMap;
  },
  {} as Record<string, number>
);

const FORMATTED_DATE_PATTERN =
  /^(\d{1,2})\s+([A-Za-z]{3,9})\s*(?:['’]\s*)?(\d{2}|\d{4})$/;
const ISO_DATE_PATTERN = /^(\d{4})-(\d{1,2})-(\d{1,2})/;

const formatDeliveryDate = (date: Date) => {
  const day = date.getDate();
  const month = MONTHS[date.getMonth()];
  const year = String(date.getFullYear()).slice(-2);

  return `${day} ${month}’${year}`;
};

const isValidDate = (date: Date) => !Number.isNaN(date.getTime());

const createLocalDate = (year: number, monthIndex: number, day: number) => {
  const date = new Date(year, monthIndex, day);

  if (
    !isValidDate(date) ||
    date.getFullYear() !== year ||
    date.getMonth() !== monthIndex ||
    date.getDate() !== day
  ) {
    return null;
  }

  return date;
};

const parseFormattedDate = (value: string) => {
  const match = value.match(FORMATTED_DATE_PATTERN);

  if (!match) return null;

  const day = Number(match[1]);
  const monthIndex = MONTH_NAME_TO_INDEX[match[2].slice(0, 3).toLowerCase()];
  const year = Number(match[3].length === 2 ? `20${match[3]}` : match[3]);

  if (
    !Number.isFinite(day) ||
    monthIndex === undefined ||
    !Number.isFinite(year)
  ) {
    return null;
  }

  return createLocalDate(year, monthIndex, day);
};

const parseIsoDate = (value: string) => {
  const match = value.match(ISO_DATE_PATTERN);

  if (!match) return null;

  const year = Number(match[1]);
  const monthIndex = Number(match[2]) - 1;
  const day = Number(match[3]);

  if (
    !Number.isFinite(year) ||
    !Number.isFinite(monthIndex) ||
    !Number.isFinite(day)
  ) {
    return null;
  }

  return createLocalDate(year, monthIndex, day);
};

export const convertDate = (str: string) => {
  const value = str?.trim();

  if (!value) return "";

  const parsedFormattedDate = parseFormattedDate(value);
  if (parsedFormattedDate) return formatDeliveryDate(parsedFormattedDate);
  if (FORMATTED_DATE_PATTERN.test(value)) return value;

  const parsedIsoDate = parseIsoDate(value);
  if (parsedIsoDate) return formatDeliveryDate(parsedIsoDate);
  if (ISO_DATE_PATTERN.test(value)) return value;

  const parsedDate = new Date(value);

  return isValidDate(parsedDate) ? formatDeliveryDate(parsedDate) : value;
};
